/** @format */

import React, { useEffect, useState } from "react";
import NavbarCustom from "../../Components/Layout/Navbar/NavbarCustom";
import Footer from "../../Components/Layout/Footer/Index";
import { useParams } from "react-router-dom";
import { LoaderCircle } from "../../Components/Layout/Card/CardLoader";
import serverAPI from "../../config/serverAPI";

function Index() {
  const { slug } = useParams();
  const [processedContent, setProcessedContent] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await serverAPI.get(`/records/images/${slug}/nt/`);
        const galleryDesc = response.data?.gallery_desc;

        if (galleryDesc) {
          // Parse the HTML content
          const parser = new DOMParser();
          const doc = parser.parseFromString(galleryDesc, "text/html");

          // Add custom classes to iframe tags
          const iframes = doc.querySelectorAll("iframe");
          iframes.forEach((iframe) => {
            iframe.classList.add("custom-iframe-class");
          });

          // Add custom classes to h1 and h2 tags
          const headingsH1 = doc.querySelectorAll("h1");
          headingsH1.forEach((text) => {
            text.classList.add("custom-text-class");
          });

          const headingsH2 = doc.querySelectorAll("h2");
          headingsH2.forEach((text) => {
            text.classList.add("custom-texth2-class");
          });

          // Add custom classes to img tags
          const images = doc.querySelectorAll("img");
          images.forEach((img) => {
            img.classList.add("custom-img-class");
          });

          // Serialize the modified HTML back to a string
          setProcessedContent(doc.body.innerHTML);
        } else {
          setProcessedContent("<p>No content available.</p>");
        }
      } catch (error) {
        console.error("Error fetching gallery data:", error);
        setProcessedContent("<p>Error loading content.</p>");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [slug]);

  return (
    <>
      {isLoading ? (
        <div className='w-full h-[100vh] flex justify-center items-center'>
          <LoaderCircle />
        </div>
      ) : (
        <>
          <NavbarCustom />
          <div className='mt-24 max-desktop:mt-20 max-tablet:mt-16 mb-8 max-w-[1200px] max-desktop:max-w-[80%] max-tablet:max-w-[100%] m-auto p-5'>
            <div
              dangerouslySetInnerHTML={{
                __html: processedContent,
              }}
            />
          </div>
          <Footer />
        </>
      )}
    </>
  );
}

export default Index;
